import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../app.service';
import { FormBuilder } from '@angular/forms'; 
import { NgxSpinnerService } from 'ngx-spinner';
import { Common } from '../common/common';
import { environment } from "src/environments/environment";


declare var $;
declare var google:any;
declare var gtag;
declare var fbq;

@Component({
  selector: 'app-sellproperty',
  templateUrl: './sellproperty.component.html',
  styleUrls: ['./sellproperty.component.css']
})

export class SellpropertyComponent implements OnInit {

  constructor(private router:Router,private service:AppService,private fb:FormBuilder,private spinner:NgxSpinnerService,private common:Common) { }

  alwarBounds = new google.maps.LatLngBounds(
    new google.maps.LatLng(environment.norteastLatLongFirst, environment.norteastLatLongSecond),
    new google.maps.LatLng(environment.southwestLatLongFirst, environment.southwestLatLongSecond)
  );

  options={
    bounds:this.alwarBounds,
    componentRestrictions: { country: 'IN' },
    strictBounds:environment.strictBounds
  }


  buyImage:any="";
  rentImage:any="";
  pgImage:any="";
  advImg:any="";
  advLink:any="";
  ngOnInit() { 
    if(environment.production){
    this.service.sendEvents("Completesellproperty", "sellproperty", "SellProperty");

    fbq('track', "CompleteSellProperty" , {
      content_type: "sellproperty",
      content_title: this.router.url,
    });
  }

    this.spinner.show();
    this.elasticTabs();
    this.service.loadScript('assets/js/owl.carousel.min.js').onload=(teste)=>{
    this.getBlogList();
    this.service.loadExternalStyles('assets/css/carousel.css');
    }
    $(".feedback-link").click(function () {
      $(".feedback-form").toggleClass("feedback-show");
      $('.feedback-form').removeClass("feedback-second-show");
      $('input[name="feedback"]').prop('checked', false);
      this.feedbackErrorMsg = "";
      this.feedbackSuccessMsg = "";
    });

    $(".close").click(function () {
      $(".feedback-form").toggleClass("feedback-show");
      $('.feedback-form').removeClass("feedback-second-show");
      $('input[name="feedback"]').prop('checked', false);
      this.feedbackErrorMsg = "";
      this.feedbackSuccessMsg = "";
    });

    $('.feedback-first input:radio').change(function () {
      if ($(this).is(":checked")) {
        $('.feedback-form').addClass("feedback-second-show");
      }
    }); 
  

    var propertyTypeBox = document.getElementById('id01');
    var budgetTypeBox = document.getElementById('id02');

  // When the user clicks anywhere outside of the outbox box, close it
  window.onclick = function(event) {
      if (event.target == propertyTypeBox) {
        $('#flatoftype').toggleClass('type-class');
        $('#budgetlist').removeClass('budget-class');
      }else if(event.target==budgetTypeBox){
        $('#budgetlist').toggleClass('budget-class');
        $('#flatoftype').removeClass('type-class');
      }else{
        $('#flatoftype').removeClass('type-class');
        $('#budgetlist').removeClass('budget-class');
      }

      $('.sharethis').click(function(){
        $(this).closest('.listing_actions').find('.share_unit').toggleClass("blockshareopt");
      });
    }

    // load home data
    this.getHomePageImage();
    this.getTestimonialList();
    this.getVerifiedProperties('1');
    this.getVerifiedProperties1('2');
    this.getVerifiedProperties2('3');
    this.getVerifiedProperties3('4');
    this.getPropertySnapshot();
    this.getHomepagePopup();
  } 

  sliderImage:any="";
  getHomePageImage(){
    this.service.get('/getHomepageBanner').subscribe(
      (data:any)=>{ 
        this.buyImage=data[0].buy_image;
        this.sliderImage=data[0].buy_image;
        this.rentImage=data[0].rent_image;
        this.pgImage=data[0].pg_image;
        this.advImg=data[0].adv_img;
        this.advLink=data[0].adv_link;
      },
      error=>{
        console.log(error.errorDesc);
      }
    )
  }
 
  testimonialList:any=[];
  getTestimonialList(){
    this.service.get('/testimonialList?featured=1').subscribe(
      (data:any)=>{
        if(data[0].error=='0'){
          this.testimonialList=data[0].result;

          setTimeout(function(){ 
            $(document).ready(function() {
              (function() {
                var showChar = 400;
                var ellipsestext = "..";
            
                $(".truncate").each(function() {
                  var content = $(this).html();
                  if (content.length > showChar) {
                    var c = content.substr(0, showChar);
                    var h = content;
                    var html =
                      '<div class="truncate-text" style="display:block">' +
                      c +
                      '<span class="moreellipses">' +
                      ellipsestext +
                      '<a href="" style="color: #db0c0c;" class="moreless more">read more</a></span></div><div class="truncate-text" style="display:none">' +
                      h +
                      '<a href="" style="color: #db0c0c;" class="moreless less">read less</a></span></div>';
            
                    $(this).html(html);
                  }
                });
            
                $(".moreless").click(function() {
                  var thisEl = $(this);
                  var cT = thisEl.closest(".truncate-text");
                  var tX = ".truncate-text";
            
                  if (thisEl.hasClass("less")) {
                    
                    cT.slideToggle();
                    cT.prev(tX).toggle();
                  } else {
                    cT.toggle();
                    cT.next(tX).fadeToggle();
                  }
                  return false;
                });
                /* end iffe */
              })();
            
              /* end ready */
            }); 
          },2000);
        }

      },error=>{
        console.log(error.errorDesc);
      }
    )
  }

 

  blogList:any=[];
  getBlogList(){
    this.service.get('/homepageFeatBlog').subscribe(
      (data:any)=>{
        if(data[0].error=='0'){
          this.blogList=data[0].result;

          setTimeout(function(){
            $(".latest-blog").owlCarousel({
              navigation : false,
              pagination : true,
              slideSpeed : 600,
              paginationSpeed : 400,
              autoPlay:true,
              items : 3,
              itemsDesktop : [1199,3],
              itemsDesktopSmall : [979,3], 
              itemsTablet: [767,2], 
              itemsMobile : [480,1],
              navigationText : ['<i class="icon-left-open"><i class="fa fa-angle-left"></i></i>','<i class="icon-right-open"><i class="fa fa-angle-right"></i></i>'] 
            }); 
          })
        }
      },error=>{
        console.log(error.errorDesc);
      }
    )
  }

  homeSearch=this.fb.group({
    looking_type:[''],
    propertytype_subcat:[''],
    location_lat:[''],
    location_long:[''],
    location:[''],
    location_sublocality:[''],
  })

  get f() { return this.homeSearch.controls; }

  handleAddressChange(event){   
    this.homeSearch.patchValue({ 
        location_lat:event.geometry.location.lat(),
        location_long:event.geometry.location.lng(),
        location:event.formatted_address,
        location_sublocality:event.address_components[0].long_name,
      });
  }

  selectCategory(value:any){
    if(value=='1'){
      this.homeSearch.patchValue({propertytype_subcat:"1,2,4"});
    }else if(value=='2'){
      this.homeSearch.patchValue({propertytype_subcat:"5,6,7"});
    }else if(value=='3'){
      this.homeSearch.patchValue({propertytype_subcat:"8,9"});
    }else if(value=='4'){ 
      this.homeSearch.patchValue({propertytype_subcat:"10,13"});
    }else if(value=='5'){  
      this.homeSearch.patchValue({looking_type:"5",propertytype_subcat:"1,2,3"});
    }

    $('.collapse').removeClass('show');
    $('#collapse'+value).addClass('show');
 
  }

  propertyTypeValue(){
    var value='Select Property Type';
    if(this.f.propertytype_subcat.value){
      var subCategoryArray=this.f.propertytype_subcat.value.split(',');
      if(this.f.looking_type.value=='1' && subCategoryArray.length==3){
        value='All Residential';
      }else if(this.f.looking_type.value=='1' && subCategoryArray.length<3){
        value='Residential ('+subCategoryArray.length+' Selected)';
      }else if(this.f.looking_type.value=='2'  && subCategoryArray.length==3){
        value='All Commercial';
      }else if(this.f.looking_type.value=='2'  && subCategoryArray.length<3){
        value='Commercial ('+subCategoryArray.length+' Selected)';
      }else if(this.f.looking_type.value=='3'  && subCategoryArray.length==2){
        value='All Agriculture';
      }else if(this.f.looking_type.value=='3'  && subCategoryArray.length<2){
        value='Agriculture ('+subCategoryArray.length+' Selected)';
      }else if(this.f.looking_type.value=='4'  && subCategoryArray.length==2){
        value='All Industry';
      }else if(this.f.looking_type.value=='4'  && subCategoryArray.length<2){
        value='Industry ('+subCategoryArray.length+' Selected)';
      }else if(this.f.looking_type.value=='5'  && subCategoryArray.length==3){
        value='PG Availability';
      }else if(this.f.looking_type.value=='5'  && subCategoryArray.length<3){
        value='PG Availability('+subCategoryArray.length+' Selected)';
      }
    }

    return value;
  }

  setPropertySubCatValue(event){
    var selCatValue=this.f.looking_type.value;
    var subCatValue=this.f.propertytype_subcat.value;
    var subCatSplit=subCatValue.split(",");

    if(((selCatValue=='1' || selCatValue=='2') && subCatSplit.length==3) || (selCatValue=='3' && subCatSplit.length==2) || (selCatValue=='4' && subCatSplit.length==2) ||  (selCatValue=='5' && subCatSplit.length==3)){
      this.homeSearch.patchValue({propertytype_subcat:event.target.value});
      $('#checkbox'+event.target.value).prop('checked', true);
    }else{
      this.homeSearch.patchValue({propertytype_subcat:$('.subcat:checked').map(function() {return this.value;}).get().join(',')});
    }
  }

  chkSearchSubTypeValue(id){
    if(this.f.propertytype_subcat.value){
      var idString=this.f.propertytype_subcat.value;
      var idArray=idString.split(',');

      var searchValue = idArray.filter(function (keyData) {
        return keyData == id;
      });

      if(searchValue.length>0){
        return searchValue[0];
      }
    }
  }
 
  mobileSearchFilter(){
    document.getElementById('search-box').style.cssText = 'display: block';
  }  
  
  closeSearchFilter(){
    document.getElementById('search-box').style.cssText = 'display: none';
  }

  elasticTabs(){
    $(document).ready(function () {
      var tabs = $('.elasticTabs');
      var selector = $('.elasticTabs').find('a').length;
      var activeItem = tabs.find('.active');
      var activeWidth = activeItem.innerWidth();
      $(".selector").css({
        "left": activeItem.position.left + "px",
        "width": activeWidth + "px"
      });
    
      $(".elasticTabs").on("click", "a", function (e) {
        e.preventDefault();
        $('.elasticTabs a').removeClass("active");
        $(this).addClass('active');
        var activeWidth = $(this).innerWidth();
        var itemPos = $(this).position();
        $(".selector").css({
          "left": itemPos.left + "px",
          "width": activeWidth + "px"
        });
      });
    });
  }
 
  searchCategory:string="buy";
  getBanner(value:string){
    this.searchCategory=value;

    this.homeSearch.reset(); 

    if(value=='buy'){
      this.sliderImage=this.buyImage; 
    }else if(value=='rent'){
      this.sliderImage=this.rentImage; 
    }else if(value=='pg'){
      this.selectCategory('5');
      this.sliderImage=this.pgImage;
    } 
  }

  searchProperty(){ 
    localStorage.setItem('homesearch',JSON.stringify(this.homeSearch.value)); 
    this.router.navigateByUrl("/search-property/"+this.searchCategory);
  }

 


  div1:boolean=true;
    div2:boolean=false;
    div3:boolean=false;
    div4:boolean=false;

    div1Function(){
        this.div1=true;
        this.div2=false;
        this.div3=false;
        this.div4=false;
        this.setResidentialCarousel();
    }

     div2Function(){
        this.div2=true;
        this.div1=false;
        this.div3=false;
        this.div4=false;
        this.setCommercialCarousel();
    }

    div3Function(){
        this.div3=true;
        this.div2=false;
        this.div1=false;
        this.div4=false;
        this.setAgricultureCarousel();
    }
     div4Function(){
        this.div3=false;
        this.div2=false;
        this.div1=false;
        this.div4=true;
        this.setIndustrialCarousel();
    }


    verifyProperties:any=[];
  verifyLoader:boolean=false;
  getVerifiedProperties(type){
 this.service.loadScript('assets/js/owl.carousel.min.js');
 this.service.loadExternalStyles('assets/css/carousel.css');
 
    this.service.get('/getVerifiedProperties?looking_type='+1+'&limit=12').subscribe(
      (data:any)=>{
        if(data[0].error=='0'){
          this.verifyProperties=data[0].result; 

          this.setResidentialCarousel();
        }
      },error=>{
        console.log(error.errorDesc);
      }
    )
  }




    verifyProperties1:any=[];
  verifyLoader1:boolean=false;
 
  getVerifiedProperties1(type){
  
 this.service.loadScript('assets/js/owl.carousel.min.js');
 this.service.loadExternalStyles('assets/css/carousel.css');
    this.service.get('/getVerifiedProperties1?looking_type='+2+'&limit=12').subscribe(
      (data:any)=>{
        if(data[0].error=='0'){
          this.verifyProperties1=data[0].result; 

          this.setCommercialCarousel();
        }
      },error=>{
        console.log(error.errorDesc);
      }
    )
  }


   verifyProperties2:any=[];
  verifyLoader2:boolean=false;
 
  getVerifiedProperties2(type){
  
  this.service.loadScript('assets/js/owl.carousel.min.js');
 this.service.loadExternalStyles('assets/css/carousel.css');
    this.service.get('/getVerifiedProperties2?looking_type='+3+'&limit=12').subscribe(
      (data:any)=>{
        if(data[0].error=='0'){
          this.verifyProperties2=data[0].result; 

          this.setAgricultureCarousel();
        }
      },error=>{
        console.log(error.errorDesc);
      }
    )
  }


   verifyProperties3:any=[];
  verifyLoader3:boolean=false;
  
  getVerifiedProperties3(type){
  this.service.loadScript('assets/js/owl.carousel.min.js');
 this.service.loadExternalStyles('assets/css/carousel.css');
  
    this.service.get('/getVerifiedProperties3?looking_type='+4+'&limit=12').subscribe(
      (data:any)=>{
        if(data[0].error=='0'){
          this.verifyProperties3=data[0].result; 

          this.setIndustrialCarousel();
        }
      },error=>{
        console.log(error.errorDesc);
      }
    )
  }

  private setResidentialCarousel() {
    setTimeout(function() {
      $(".latest-prop").owlCarousel({
        navigation : true,
        pagination : true,
        slideSpeed : 600,
        paginationSpeed : 400,
        autoPlay:true,
        items : 4,
        itemsDesktop : [1199,4],
        itemsDesktopSmall : [979,3], 
        itemsTablet: [767,2], 
        itemsMobile : [480,1],
        navigationText : ['<i class="icon-left-open"><i class="fa fa-angle-left"></i></i>','<i class="icon-right-open"><i class="fa fa-angle-right"></i></i>'] 
      });
    })
  }

  private setCommercialCarousel() {
    setTimeout(function() {
      $(".latest-prop1").owlCarousel({
        navigation : true,
        pagination : true,
        slideSpeed : 600,
        paginationSpeed : 400,
        autoPlay:true,
        items : 4,
        itemsDesktop : [1199,4],
        itemsDesktopSmall : [979,3], 
        itemsTablet: [767,2], 
        itemsMobile : [480,1],
        navigationText : ['<i class="icon-left-open"><i class="fa fa-angle-left"></i></i>','<i class="icon-right-open"><i class="fa fa-angle-right"></i></i>'] 
      });
    })
  }

  private setAgricultureCarousel() {
    setTimeout(function() {
      $(".latest-prop2").owlCarousel({
        navigation : true,
        pagination : true,
        slideSpeed : 600,
        paginationSpeed : 400,
        autoPlay:true,
        items : 4,
        itemsDesktop : [1199,4],
        itemsDesktopSmall : [979,3], 
        itemsTablet: [767,2], 
        itemsMobile : [480,1],
        navigationText : ['<i class="icon-left-open"><i class="fa fa-angle-left"></i></i>','<i class="icon-right-open"><i class="fa fa-angle-right"></i></i>'] 
      });
    })
  }

  private setIndustrialCarousel() {
    setTimeout(function() {
      $(".latest-prop3").owlCarousel({
        navigation : true,
        pagination : true,
        slideSpeed : 600,
        paginationSpeed : 400,
        autoPlay:true,
        items : 4,
        itemsDesktop : [1199,4],
        itemsDesktopSmall : [979,3], 
        itemsTablet: [767,2], 
        itemsMobile : [480,1],
        navigationText : ['<i class="icon-left-open"><i class="fa fa-angle-left"></i></i>','<i class="icon-right-open"><i class="fa fa-angle-right"></i></i>'] 
      });
    })
  }
 

  addToWishlist(property_type,property_id,event){ 
    if(this.service.isLoggedIn()){ 
      this.service.post('/addPropertyWishlist',{"type":"Web","auth_token":this.service.getAuthorizationToken(),"property_type":property_type,"property_id":property_id}).subscribe(
        data=>{
          if(data[0].error=='0'){
            event.srcElement.classList.remove('fa-heart-o');
            event.srcElement.classList.remove('fa-heart');
            if(data[0].feature==1){
              event.srcElement.classList.add('fa-heart');
            }else{
              event.srcElement.classList.add('fa-heart-o');
            }   
          }else{
            alert('something went wrong.please try again.');
          } 
        },
        error=>{
          console.log('in error');
        }
      )
    }else{
      $('#loginModal').modal('toggle');
    }

  }

  get chkPropertyWishlistId(){ return this.service.getPropertyWishlistId; }


  propertysnapshot:any;
  getPropertySnapshot(){
    this.service.get('/propertySnapshotData').subscribe(
      (data:any)=>{
        if(data[0].error=='0'){
          this.propertysnapshot=data[0];
        }
      },error=>{
        console.log('in error');
      }
    )
  }
 
  homepagebanner:any;
  getHomepagePopup(){
    this.service.get('/homepagePopBanner').subscribe(
      (data:any)=>{
        if(data[0].error=='0'){
          this.homepagebanner=data[0];
        }
      },error=>{
        console.log('in error');
      }
    )
  }

  searchPropertyByNearYou(type){
    localStorage.setItem('homesearch',JSON.stringify( {looking_type: "1", propertytype_subcat: type, location_lat: "", location_long: "", location: ""}));
     this.router.navigateByUrl("/search-property/buy");
  }
  
  sharePost(type,url){   
    this.common.sharePost(type,'property-details/');
  }
}
